module.exports = __webpack_public_path__ + "static/img/model-bg28.ce79b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg28.jpg
// module id = AzSa
// module chunks = 0